import OrderItemStyle from "../enum/OrderItemStyle";

const OrderItemStyleNameMap = {
    [OrderItemStyle.JOINED]: "",
    [OrderItemStyle.PER_ITEM_PER_LINE]: "仅首行商品显示订单信息",
    [OrderItemStyle.PER_ITEM_PER_LINE_WITH_ORDER_INFO]: "每行商品均显示订单信息",
};

export default OrderItemStyleNameMap;
